/**
 * Notification rule remove button
 */

import React from "react";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";

import { Button } from "react-bootstrap";

import Icon from "components/Icons/Icon";
import Alert from "components/Common/Alert";

import {
  requestNotificationsRemoveRuleStart,
  requestNotificationsRemoveRuleNotified
} from "services/redux/actions";
import {
  singleSiteNotificationsRemoveRuleStart,
  singleSiteNotificationsRemoveRuleNotified
} from "services/redux/actions/singleSites";

import { withT } from "services/translation/";

function RemoveRule({
  origin,
  id,
  removeRuleSuccess,
  removingRule,
  t
}) {
  const dispatch = useDispatch();

  if (removeRuleSuccess === id) {
    // Reset success status
    if (origin === "SingleSite") {
      dispatch(singleSiteNotificationsRemoveRuleNotified());
    } else {
      dispatch(requestNotificationsRemoveRuleNotified());
    }
    Alert({
      text: t("remove_rule_success"),
      icon: "success"
    });
  }

  return (
    <Button
      data-testid="notifications-remove-rule"
      onClick={() => {
        Alert({
          text: t("confirm_message"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: t("confirm_button"),
          cancelButtonText: t("cancel_button")
        }).then(result => {
          if (result.value) {
            if (origin === "SingleSite") {
              dispatch(singleSiteNotificationsRemoveRuleStart({ params: { id } }));
            } else {
              dispatch(requestNotificationsRemoveRuleStart({ params: { id } }));
            }
          }
        });
      }}
      size="sm"
      variant="danger"
      disabled={removingRule}>
      <Icon data-testid="remove-icon" className="fas fa-times" />
    </Button>
  );
}
RemoveRule.propTypes = {
  /**
   * @param id the id of the rule to be deleted
   */
  id: PropTypes.number.isRequired,

  /**
   * @param removingRule rule removal loading status
   */
  removingRule: PropTypes.any,

  /**
   * @param removeRuleError error status for rule removal
   */
  removeRuleError: PropTypes.object.isRequired,

  /**
   * @param removeRuleSuccess success status for rule removal
   */
  removeRuleSuccess: PropTypes.any,

  /**
   * @param t translation function
   */
  t: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    removingRule: state.notifications.rules.actions.remove.loading === true,
    removeRuleError: state.notifications.rules.actions.remove.error,
    removeRuleSuccess: state.notifications.rules.actions.remove.success
  };
};

export default withT(
  connect(mapStateToProps)(RemoveRule),
  "site_overview.side_pane.manage_notifications.remove_rule"
);
